import { render, staticRenderFns } from "./ManagementStructure.vue?vue&type=template&id=4f131616&"
import script from "./ManagementStructure.vue?vue&type=script&lang=js&"
export * from "./ManagementStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports